/* @flow */

import React, { Component } from 'react';

// TODO: Only used for sticky menu, to remove when sticky appears in semantic ui react
import $ from 'jquery';

// eslint-disable-next-line no-unused-vars
import { EditorState, Editor, RichUtils, Entity, Modifier } from 'draft-js';
import { ChromePicker } from 'react-color';
import EditoTextControlButton from './RichTextMenuButton';
import {
  BLOCK_TYPES,
  HEADER_TYPES,
  INLINE_STYLES,
  ALIGN_TYPES,
  getBlockAlignment,
} from 'utils/richtext';
import shallowCompare from 'react-addons-shallow-compare';
import classNames from 'classnames';

import { Button, Segment } from 'semantic-ui-react';

type Props = {
  parentState: object,
  onChange?: (nextState: object) => void,
  readOnly?: boolean,
  withHeaders?: boolean,
  withTextBlocks?: boolean,
  withAlignment?: boolean,
  withInlineBasics?: boolean,
  withLinks?: boolean,
  withColors?: boolean,
  itemId?: any,
};

//TODO: Add maxWidth equal to width on Segment encaplusating the editor
class RichTextItem extends Component {
  props: Props;

  constructor(props) {
    super(props);

    this.state = {
      showURLInput: false,
      showColorPicker: false,
      urlValue: '',
      currentColor: '',
    };

    this.focus = () => this.textEdito.focus();

    this.onChange = editorState => {
      const { onChange } = this.props;

      onChange && onChange(editorState);
    };

    this._onURLChange = evt => {
      this.setState({ urlValue: evt.target.value });
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentDidMount() {
    if (this.props.parentState.getCurrentContent().getBlockMap().size > 5) {
      const { itemId } = this.props;

      if (itemId) {
        const selector = '#editoMenu' + itemId;
        $(selector).sticky({
          offset: 50,
          bottomOffset: 50,
          observeChanges: true,
          context: '#edito' + itemId,
          jitter: 50000,
        });
      }
    }
  }

  _focusNow = () => {
    setTimeout(() => this.textEdito.focus(), 0);
  };

  _onColorChange = newColor => {
    this.setState({
      currentColor:
        'rgb(' +
        newColor.rgb.r +
        ',' +
        newColor.rgb.g +
        ',' +
        newColor.rgb.b +
        ')',
    });
  };

  _applyColor = evt => {
    const color = this.state.currentColor;

    const { parentState } = this.props;
    const selection = parentState.getSelection();

    const appliedColors = parentState
      .getCurrentInlineStyle()
      .filter(style => style && style.substring(0, 3) === 'rgb');

    let nextEditorState = parentState;

    // TODO: reduce instead of map
    appliedColors.map(appliedColor => {
      nextEditorState = EditorState.push(
        nextEditorState,
        Modifier.removeInlineStyle(
          parentState.getCurrentContent(),
          selection,
          appliedColor
        ),
        'change-inline-style'
      );

      // anti-warning ugly thingy
      return {};
    });

    nextEditorState = RichUtils.toggleInlineStyle(nextEditorState, color);

    this.onChange(nextEditorState);
    this.setState(
      {
        showColorPicker: false,
      },
      this._focusNow
    );
  };

  _applyAlignment = (editorState, style, removeStyles = []) => {
    const currentContent = editorState.getCurrentContent();
    const selection = editorState.getSelection();
    const selectionIsBackward = selection.getIsBackward();

    let changes = {
      anchorOffset: 0,
      focusOffset: currentContent
        .getBlockForKey(selection.getFocusKey())
        .getLength(),
    };

    if (selectionIsBackward) {
      changes = {
        focusOffset: 0,
        anchorOffset: currentContent
          .getBlockForKey(selection.getAnchorKey())
          .getLength(),
      };
    }

    const selectWholeBlocks = selection.merge(changes);
    const modifiedContent = Modifier.applyInlineStyle(
      currentContent,
      selectWholeBlocks,
      style
    );
    const finalContent = removeStyles.reduce((content, style) => {
      return Modifier.removeInlineStyle(content, selectWholeBlocks, style);
    }, modifiedContent);
    return EditorState.push(editorState, finalContent, 'change-inline-style');
  };

  _toggleAlignment = selection => {
    const classN = selection.replace('align ', '');

    const getOppositeAlignments = alignmentClass => {
      switch (alignmentClass) {
        case 'right':
          return ['left', 'center'];
        case 'center':
          return ['left', 'right'];
        case 'left':
          return ['center', 'right'];
        default:
          return [];
      }
    };

    this.onChange(
      this._applyAlignment(
        this.props.parentState,
        classN,
        getOppositeAlignments(classN)
      )
    );
  };

  _toggleColorPicker = blockType => {
    this.setState({ showColorPicker: !this.state.showColorPicker });
  };

  _toggleBlockType = blockType => {
    this.onChange(RichUtils.toggleBlockType(this.props.parentState, blockType));
  };

  _toggleInlineStyle = inlineStyle => {
    this.onChange(
      RichUtils.toggleInlineStyle(this.props.parentState, inlineStyle)
    );
  };

  _promptForLink = e => {
    e.preventDefault();
    const { parentState } = this.props;
    const selection = parentState.getSelection();
    if (!selection.isCollapsed()) {
      const contentState = parentState.getCurrentContent();
      const startKey = parentState.getSelection().getStartKey();
      const startOffset = parentState.getSelection().getStartOffset();
      const blockWithLinkAtBeginning = contentState.getBlockForKey(startKey);
      const linkKey = blockWithLinkAtBeginning.getEntityAt(startOffset);

      let url = '';
      if (linkKey) {
        const linkInstance = contentState.getEntity(linkKey);
        url = linkInstance.getData().url;
      }

      this.setState(
        {
          showURLInput: true,
          urlValue: url,
        },
        () => {
          setTimeout(() => this.textEditoUrl.focus(), 0);
        }
      );
    }
  };

  _confirmLink = e => {
    e.preventDefault();
    const { urlValue } = this.state;

    const validatedUrl = !urlValue.match(/^[a-zA-Z]+:\/\//)
      ? 'http://' + urlValue
      : urlValue;
    const { parentState } = this.props;

    // Can be IMMUTABLE, if so, whole link( and its characters) will be removed if one of its characters is removed
    const entityKey = Entity.create('LINK', 'MUTABLE', { url: validatedUrl });
    this.onChange(
      RichUtils.toggleLink(parentState, parentState.getSelection(), entityKey)
    );
    this.setState(
      {
        showURLInput: false,
        urlValue: '',
      },
      this._focusNow
    );
  };

  _cancelLink = e => {
    e.preventDefault();

    this.setState(
      {
        showURLInput: false,
        urlValue: '',
      },
      this._focusNow
    );
  };

  _onLinkInputKeyDown = e => {
    if (e.which === 13) {
      this._confirmLink(e);
    }
  };

  _removeLink = e => {
    e.preventDefault();
    const { parentState } = this.props;
    const selection = parentState.getSelection();
    if (!selection.isCollapsed()) {
      this.onChange(RichUtils.toggleLink(parentState, selection, null));
    }
  };

  _handleKeyCommand = command => {
    const newState = RichUtils.handleKeyCommand(
      this.props.parentState,
      command
    );
    if (newState) {
      this.onChange(newState);
      return 'handled';
    }
    return 'not-handled';
  };

  _blockStyler = block => {
    let alignment = getBlockAlignment(block);
    if (!block.getText()) {
      const previousBlock = this.props.parentState
        .getCurrentContent()
        .getBlockBefore(block.getKey());
      if (previousBlock) {
        alignment = getBlockAlignment(previousBlock);
      }
    }
    return `alignment--${alignment}`;
  };

  render() {
    const { parentState } = this.props;

    const { _handleKeyCommand, onChange, _blockStyler } = this;

    const {
      readOnly,
      withHeaders,
      withTextBlocks,
      withAlignment,
      withInlineBasics,
      withLinks,
      withColors,
    } = this.props;

    const BlockStyleControls = props => {
      const selection = props.editorState.getSelection();
      const blockType = props.editorState
        .getCurrentContent()
        .getBlockForKey(selection.getStartKey())
        .getType();

      return (
        <Button.Group>
          {withHeaders &&
            HEADER_TYPES.map(type => (
              <EditoTextControlButton
                key={type.label}
                active={type.style === blockType}
                label={type.label}
                onToggle={props.onToggle}
                styleEffect={type.style}
              />
            ))}
          {withTextBlocks &&
            BLOCK_TYPES.map(type => (
              <EditoTextControlButton
                key={type.label}
                active={type.style === blockType}
                label={type.label}
                onToggle={props.onToggle}
                styleEffect={type.style}
                displayStyle={type.display_style}
              />
            ))}
        </Button.Group>
      );
    };

    const InlineStyleControls = props => {
      const currentStyle = props.editorState.getCurrentInlineStyle();
      return (
        <Button.Group style={{ marginLeft: '5px' }}>
          {INLINE_STYLES.map(type => (
            <EditoTextControlButton
              key={type.label}
              active={currentStyle.has(type.style)}
              label={type.label}
              onToggle={props.onToggle}
              styleEffect={type.style}
              displayStyle={type.display_style}
            />
          ))}
        </Button.Group>
      );
    };

    const AlignmentControls = props => {
      const currentStyle = props.editorState.getCurrentInlineStyle();
      return (
        <Button.Group style={{ marginTop: '5px', marginLeft: '5px' }}>
          {ALIGN_TYPES.map(type => (
            <EditoTextControlButton
              key={type.label}
              label={type.label}
              active={currentStyle.has(type.style.replace('align ', ''))}
              onToggle={props.onToggle}
              styleEffect={type.style}
              displayStyle={type.display_style}
            />
          ))}
        </Button.Group>
      );
    };

    const LinkControls = props => {
      const current = props.editorState.getSelection();
      const noSelection =
        current.getStartKey() === current.getEndKey() &&
        current.getStartOffset() === current.getEndOffset();
      return (
        <Button.Group style={{ marginLeft: '5px' }}>
          <Button
            type="button"
            icon="linkify"
            onMouseDown={this._promptForLink}
            disabled={noSelection}
          />
          <Button
            type="button"
            icon="unlinkify"
            onMouseDown={this._removeLink}
            disabled={noSelection}
          />
        </Button.Group>
      );
    };

    const ColorControls = props => {
      return (
        <Button.Group style={{ marginLeft: '5px' }}>
          <EditoTextControlButton
            label="Couleur"
            active={this.state.showColorPicker}
            onToggle={props.onToggle}
            styleEffect="color"
          />
        </Button.Group>
      );
    };

    const getBlockStyle = block => {
      switch (block.getType()) {
        case 'blockquote':
          return 'RichEditor-blockquote';
        default:
          return _blockStyler(block);
      }
    };

    const getCurrentColor = () => {
      const appliedColor = this.props.parentState
        .getCurrentInlineStyle()
        .findLast(style => style && style.substring(0, 3) === 'rgb');

      if (this.state.currentColor) {
        return this.state.currentColor;
      } else if (appliedColor) {
        return appliedColor;
      } else {
        return '';
      }
    };

    const applyColorStyles = (style, block) => {
      let output = {};

      const colorExists = style.findLast(
        styleUnit => styleUnit && styleUnit.substring(0, 3) === 'rgb'
      );
      if (colorExists) {
        return {
          color: colorExists,
        };
      }
      return output;
    };

    const displayControls = !readOnly && (
      <div>
        {(withHeaders || withTextBlocks) && (
          <BlockStyleControls
            editorState={parentState}
            onToggle={this._toggleBlockType}
          />
        )}
        {withInlineBasics && (
          <InlineStyleControls
            editorState={parentState}
            onToggle={this._toggleInlineStyle}
          />
        )}
        {withLinks && <LinkControls editorState={parentState} />}
        {withAlignment && (
          <AlignmentControls
            editorState={parentState}
            onToggle={this._toggleAlignment}
          />
        )}
        {withColors && <ColorControls onToggle={this._toggleColorPicker} />}
      </div>
    );

    const displayLinkHandler = this.state.showURLInput && (
      <div className="ui action input" style={{ marginTop: '10px' }}>
        <input
          onChange={this._onURLChange}
          type="text"
          ref={ref => {
            this.textEditoUrl = ref;
          }}
          value={this.state.urlValue}
          onKeyDown={this._onLinkInputKeyDown}
          placeholder="Lien hypertexte"
        />
        <Button
          type="button"
          icon="checkmark"
          onMouseDown={this._confirmLink}
        />
        <Button
          type="button"
          color="red"
          icon="remove"
          onMouseDown={this._cancelLink}
        />
      </div>
    );

    const displayColorPicker = this.state.showColorPicker && (
      <div style={{ marginTop: '10px' }}>
        <ChromePicker
          color={getCurrentColor()}
          onChangeComplete={this._onColorChange}
          disableAlpha
        />
        <div style={{ marginTop: '10px' }}>
          <Button type="button" primary onMouseDown={this._applyColor}>
            Appliquer
          </Button>
          <Button type="button" onMouseDown={this._toggleColorPicker}>
            Annuler
          </Button>
        </div>
      </div>
    );

    const menuClassname = classNames({
      'ui sticky': parentState.getCurrentContent().getBlockMap().size > 5,
    });

    return (
      <div className="RichEditor-root" style={{ marginRight: '10px' }}>
        <div id={'editoMenu' + this.props.itemId} className={menuClassname}>
          {displayControls}
          {displayLinkHandler}
          {displayColorPicker}
        </div>
        <Segment id={'edito' + this.props.itemId} onClick={this.focus}>
          <Editor
            blockStyleFn={getBlockStyle}
            customStyleFn={applyColorStyles}
            editorState={parentState}
            handleKeyCommand={_handleKeyCommand}
            onChange={onChange}
            ref={ref => {
              this.textEdito = ref;
            }}
            readOnly={this.props.readOnly}
          />
        </Segment>
      </div>
    );
  }
}

export default RichTextItem;



// WEBPACK FOOTER //
// ./src/shared/components/RichTextItem.js